<template>

	<div>

		<div class="content-header" v-if="allowedAccess">
			<div class="content-header-inner">
				<h1 class="content-header-title" v-html="searchPageTitle" />
				<SearchBox 
					:title="searchBoxTitle"
					:inStrip="!isSearchPage||resultsTable.countTotal>0"
					:newTab="!isSearchPage"
					:openByDefault="isSearchPage"
					:showExports="!isSearchPage&&!showRunBox&&(tabStatus==='complete'||tableName==='content-keywords--stats')"
					:hideFromExport="hideFromExport"
					:filter="filter"
					:tabId="actualTabId"
					:key="searchBoxKey"
					:triggerNewSearch="triggerNewSearch"
					:description="searchBoxDescription"
					:formInput="searchBoxFormInput"
					:pageType="pageType"
					:dropdown="searchBoxDropdown"
					:dropdown2="searchBoxDropdown2"
					:creatingReport="creatingReport"
					:fixed="newSearchFixed"
					:buttonOnly="true"
					:readOnly="readOnly"
					:init="isSearchPage&&!list.countTotal"
					@submit="submitKeywords"
					@reset="resetSearchBox"
					@create-report="createReport"
					v-if="showSearchBox&&!sideMenu"
					class="init"
				/>	
			</div>
		</div>

		<section 
			:class="{'outer-pad': true, 'padding-top': true, overflow: isSearchPage, 'hidden-from-export': hideFromExport[tabId] }" v-if="!allowedAccess"
		>

			<div :class="{'info-panel': true,'not-allowed-wrap':true}">

				<div :class="{'not-allowed-bg': true}"></div>

				<div class="not-allowed">

					<div class="header-info">

						<h2 class="header-title center">Content &amp; Keywords</h2>

					</div>

					<p class="not-ready">
						<span v-if="isTrial">
							Want to try this for FREE?<br>
							Upgrade to the Pioneer 500 package and continue your FREE Trial (card required for Pioneer trial).<br>
							<router-link to="/account/subscriptions/#pioneer" class="large-button">Click here to upgrade trial</router-link>
						</span>
						<span v-if="!isTrial">
							This feature is only available on our Pioneer plan.<br>
							<router-link to="/account/subscriptions/#pioneer" class="large-button">Click here to upgrade.</router-link>
						</span>
					</p>

					<span class="video" @click="watchVideo">
						<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 117.1 95.15" style="enable-background:new 0 0 117.1 95.15;" xml:space="preserve">
						<path style="fill:#F95930;" class="st" d="M99.72,6.1H19.38c-7.23,0-13.11,5.88-13.11,13.11v56.74c0,7.23,5.88,13.11,13.11,13.11h80.33
						c7.23,0,13.11-5.88,13.11-13.11V19.21C112.82,11.98,106.94,6.1,99.72,6.1z M47.64,63.46V31.69l25.74,15.89L47.64,63.46z"/>
						</svg>
						<span class="label">Watch a video about Content &amp; Keywords</span>
					</span>

				</div>

			</div>

		</section>

		<section 
			:class="{'outer-pad': true, 'padding-top': false, overflow: isSearchPage, 'hidden-from-export': hideFromExport[actualTabId] }" v-if="allowedAccess&&(!isSearchPage||resultsTable.countTotal>0)"
		>

			<div :class="{'info-panel': true, 'has-menu': !!md5Key, overflow: isSearchPage, 'has-side-menu': sideMenu&&!isSearchPage, overflow:(showRunBox&&filter==='to-improve'),'no-min-height': ( showStats && loadingText==='' )}" :key="reloadKey">

				<div class="search-box-wrap la">

					<SearchBox 
						:title="searchBoxTitle"
						:inStrip="!isSearchPage||resultsTable.countTotal>0"
						:newTab="!isSearchPage"
						:openByDefault="isSearchPage"
						:showExports="!isSearchPage&&!showRunBox&&tabStatus==='complete'"
						:hideFromExport="hideFromExport"
						:filter="filter"
						:tabId="tabId"
						:key="searchBoxKey"
						:triggerNewSearch="triggerNewSearch"
						:description="searchBoxDescription"
						:formInput="searchBoxFormInput"
						:pageType="pageType"
						:dropdown="searchBoxDropdown"
						:dropdown2="searchBoxDropdown2"
						:fixed="newSearchFixed"
						:creatingReport="creatingReport"
						:readOnly="readOnly"
						@submit="submitKeywords"
						@reset="resetSearchBox"
						@create-report="createReport"
						v-if="showSearchBox&&sideMenu"
					/>

				</div>

				<div class="info-panel-inner">

					<TopMenu 
						:tabs="tabs" 
						:md5Key="md5Key" 
						v-if="md5Key&&allStatus==='complete'" 
						:side="sideMenu"
						:baseURI="pageName"
						:tips="tips" 
						:readOnly="readOnly"
					/>

					<TopMenu 
						:tabs="subTabs" 
						:md5Key="md5Key"
						:tabId="tabId"
						:subTabId="subTabId"
						:tabType="tab.type"
						:tips="tips" 
						v-if="showSubTabs" 
						:sub="true"
						@newTab="newTab"
						@saveTab="saveTab"
						@deleteTab="deleteTab"
						:readOnly="readOnly"
					/>

					<div class="info-panel-inner-inner" v-if="showBacklinks">

						<Backlinks
							:type="tab.type"
							:tabId="tabId"
							:md5Key="md5Key"
						/>

					</div>

					<div class="info-panel-inner-inner" v-if="!showBacklinks">

						<h2 v-html="searchBoxTitle" v-if="showMainTitle" class="main-title" /><div class="show-hidden" v-if="(filter==='paa'||filter==='auto'||filter==='content-ideas'||filter==='topic-cluster')&&!showRunBox&&!onTheCase">
							<Switcher 
								v-model="showHidden"
								:sameColour="true"
								class="switcher"
								:switcherLabel="'Show hidden'"
							/>
						</div>

					
						<PageMessage :invert="toImproveCount===0" :class="{'to-improve-info':true,results:toImproveCount>0}" v-if="toImproveProject">
							This is connected to your project <span>{{toImproveProject}}</span>, <span @click="clearToImprove" class="link">to clear this and start again click here</span>.
						</PageMessage>

						<PageMessage :invert="true" v-if="showStillProcessing">
							We are still fetching your questions and popular filters. This won't take long.
						</PageMessage>

						<KeywordStats 
							v-if="showStats" 
							:tabs="tabs"
							:md5Key="md5Key"
							:keyword="searchKeyword"
						/>

						<div v-if="!showStats">

							<span :class="{'pending-info':true, base: showResults, error: tabStatus==='error', fullMenu: fullMenu}" v-if="onTheCase">

								<h3 v-html="pendingTitle" v-if="!showResults" />

								<p v-html="pendingInfo" v-if="!showResults" />

								<Loading position="internal" class="pending-loader" v-if="tabStatus!=='error'" />

								<span class="large-button mini" v-html="notifyTaskStatus?'Cancel Email Notifcation':'Get An Email When It\'s Done'" @click="notifyTask(!notifyTaskStatus)" v-if="!showResults&&tabStatus!=='error'&&(showOnTheCaseEmailButton||notifyTaskStatus)" />

								<span class="large-button mini" v-html="'Try Again'" @click="tryAgain" v-if="tabStatus==='error'" />

								<ActionsBar v-if="showResults">

									<h3 v-html="pendingTitle" />

									<p v-html="pendingInfo" />

									<span class="large-button mini" v-html="notifyTaskStatus?'Cancel Email Notifcation':'Get An Email When It\'s Done'" @click="notifyTask(!notifyTaskStatus)" v-if="tabStatus!=='error'&&(showOnTheCaseEmailButton||notifyTaskStatus)" />

									<span class="large-button mini" v-html="'Try Again'" @click="tryAgain" v-if="tabStatus==='error'" />

								</ActionsBar>

							</span>

							<SearchBox 
								:showExports="false"
								:inStrip="true"
								:secondary="filter"
								:filter="filter"
								:title="runBoxTitle"
								:description="runSearchBox.description" 
								:dropdown="runSearchBox.dropdown" 
								:readOnly="readOnly"
								@submit="submitSecondary"
								v-if="showRunBox"
							/>

							<span v-if="toImproveMessage" :class="{'pending-info':true,fullMenu:fullMenu}">
								<h3>To Improve</h3>
								<p v-html="toImproveMessage" />
								<span class="large-button mini" v-if="projectListLoaded" @click="goToProjects">Go to projects</span>
							</span>

							<div 
								:class="{filters:true, 'has-word-breakdowns': (filter==='overview'&&termCounts.length>0)}"
								v-if="showExportFilter"
								:key="'view-hide-'+tableKey"
							>
								<h3 class="filter-title">Untick to hide from view/export &nbsp;<Tip class="mini"><span v-if="filter==='overview'">You can filter by the following:<br>
<strong>Exact Term</strong> - Keywords that contain the exact match term you are researching.<br>
<strong>Contains Term Words</strong> - Keywords that contain words from the term you are researching. This may not be all the words and it may not be in the exact order.<br>
<strong>Related Terms</strong> - All other terms (not containing part or all of the term you are researching)</span><span v-if="filter==='questions'||filter==='popular'">Filter by popular words within your keyword research data.</span></Tip> &nbsp;&nbsp;Toggle all <span @click="toggleFilters(true)">On</span> | <span @click="toggleFilters(false)">Off</span></h3>
								<FormInput
									type="checkbox"
									name="types"
									v-model="selectedFilters[filter]"
									:inline="true"
									:items="filtersProcessed"
									fontSize="14"
									:disabled="true"
									:lowLabelPadding="true"
								/>
							</div>

							<div v-if="showResults" :class="{'result-wrap': true, 'has-result-menu': subMenu.length>0}">

								<div class="one-click" v-if="oneClickAllowed&&isSearchPage&&resultsTable.countTotal>0">

									<Switcher 
										v-model="oneClick"
										:sameColour="true"
										class="one-click-switcher"
										:switcherLabel="'One click analysis'"
									/>

									<Tip 
										position="fromRight"
									>When this is enabled, clicking a "Not Run" button in the table will automatically start that action and the analysis credits for that action will be deducted from your account (click the link in the Analysis Credits box in the bottom right for more information).</Tip>

								</div>

								<div v-if="filter==='content-ideas'">

									<span class="large-button flip-colours mini" @click="deleteFilter(true)" v-if="tabStatus==='complete'&&isAdmin">Reload Supporting Content Ideas for "{{searchKeyword}}"</span>

								</div>

								<div class="result-menu" v-if="subMenu.length>0">

									<span
										v-for="(subMenuItem, subMenuItemIndex) in subMenu" 
										:key="subMenuItemIndex"
										:class="{'result-menu-item': true,selected:!!subMenuItem.selected,hide:!!subMenuItem.hide,hideHidden:!showHidden}"
										@click="subMenuItemClick(subMenuItemIndex)"
									>
										<font-awesome-icon 
											:icon="subMenuItem.hide?'eye':'eye-slash'" 
											:style="{ color: '#ffffff' }" 
											:title="subMenuItem.hide?'Un-hide from export':'Hide from export'" 
											:class="'eyed'" 
											@click="hideContentIdeas($event,subMenuItem._id,!subMenuItem.hide)"
										/> 
										{{subMenuItem.label}}
									</span>

								</div>

								<div :class="{ib:filter==='content-ideas'}">

									<Table
										v-if="resultType==='table'"
										:key="tableKey"
										:headings="tableHeadings"
										:items="resultsTable.items" 
										:pages="resultsTable.pages"
										:page="resultsTable.page"
										:count="resultsTable.count"
										:loading="table.loading"
										:sorted="resultsTable.sorted"
										:searchMultiple="searchMultiple"
										:searchMultipleValues="tabSearchFilters"
										:searchMultipleDescription="searchDescription"
										searchMultipleTitle="Search"
										:searchMultipleComparisons="comparisons"
										:meta="tableMeta"
										:name="tableName"
										@closeSearchMultiple="closeSearchMultiple"
										@pagination="pagination"
										@sort="sort"
										@selected="keywordActions"
										@search="search"
										@selectKeyword="selectKeyword"
										@showAssignProjectModal="showAssignProjectModal"
										@trackKeyword="trackKeyword"
										@contentHeadingIdeas="keywordContentIdeas"
										@oneClick="oneClickAnalysis"
										@deleteAll="deleteAll"
										@tableMounted="tableMounted"
										:searchSetup="searchSetup"
										:searchTitle="searchMultiple?'Filters':'Search Results'"
										loadingText="Loading keywords..."
										:emptyLabel="emptyTableLabel"
										emptySearch="There were no keywords matching your search"
										:class="{results:true, 'no-corners': true, 'no-bg-search': searchMultiple, 'has-word-breakdowns': (filter==='overview'&&termCounts.length>0)}"
									/>

									<div class="word-breakdowns" v-if="filter==='overview'&&termCounts.length>0" :key="'breakdown'+tableKey">

										<h4 class="word-breakdowns-title">Word breakdown</h4>

										<span
											v-for="(termCount, termCountIndex) in termCounts" 
											:key="'word-breakdown-'+termCountIndex"
											:class="{'word-breakdown': true}"
										>

											<FormInput 
												type="checkbox"
												:name="'wb--'+termCountIndex"
												:id="'wb--'+termCount.keyword"
												:labelStyles="{'padding-bottom':'4px'}"
												:label="termCount.keyword + ' (' + termCount.count + ')'"
												@clicked="checkWordBreakdowns(null,null,true)"
												v-model="termCounts[termCountIndex].checked"
												fontSize="14"
											/>

											<div v-if="termCounts[termCountIndex].checked&&termCounts[termCountIndex].related.length>0">

												<span
													v-for="(relatedTerm, relatedTermIndex) in termCounts[termCountIndex].related" 
													:key="'word-breakdown-related-'+relatedTermIndex"
													:class="{'word-breakdown': true,related:true}"
												>

													<FormInput 
														type="checkbox"
														fontSize="14"
														@clicked="checkWordBreakdowns"
														:name="'wb--'+termCount.keyword+'--'+relatedTerm.keyword"
														:id="'wb--'+termCount.keyword+'--'+relatedTerm.keyword"
														:labelStyles="{'padding-bottom':'4px'}"
														:label="relatedTerm.keyword + ' (' + relatedTerm.count + ')'"
														v-model="termCounts[termCountIndex].related[relatedTermIndex].checked"
													/>

												</span>

											</div>

										</span>

									</div>

								</div>

								<div
									v-if="resultType==='paa'&&paa&&paa.checked" 
								>

									<span class="large-button flip-colours mini" @click="deleteFilter(true)" v-if="tabStatus==='complete'&&isAdmin">Reload PAA for "{{searchKeyword}}"</span>

									<IndentList 
										:list="paa.results"
										v-if="paa.results.length>0"
										finalActionName="clickedPAA"
										finalAction2Name="clickedHidePAA"
										finalAction3Name="clickedHighlightPAA"
										@clickedPAA="clickedPAA"
										@clickedHidePAA="clickedHide"
										@clickedHighlightPAA="clickedHighlightPAA"
										:googleURL="googleURL"
										:highlighted="highlighted"
										:highlighted2="isCheckingPAAChild||-1"
										:subTabId="subTabId"
										:showHidden="showHidden"
										:readOnly="readOnly"
										:showBincolulars="['pending','in-progress'].indexOf(tabStatus)<0"
									/>

									<p v-if="paa.results.length===0">No results found - We couldn't find any People Also Ask questions on the search results for "{{searchKeyword}}" (<strong>your analysis credits have been returned</strong>)</p>

								</div>

								<AutoSuggest
									v-if="resultType==='auto'"
									:searchKeyword="searchKeyword"
									:auto="auto"
									:tab="tab"
									:subTabId="subTabId"
									:md5Key="md5Key"
									:showHidden="showHidden"
									@fetchKeywords="fetchKeywords"
									@deleteFilter="deleteFilter(true)"
								/>

								<TopicCluster
									v-if="resultType==='topic-cluster'"
									:data="topicalClusterIdeasAll"
									:tab="tab"
									:subTabId="subTabId"
									:md5Key="md5Key"
									:googleURL="googleURL"
									:showHidden="showHidden"
									@clickedHide="clickedHide"
								/>

								<ActionsBar v-if="tableItemSelectedProcessed._ids.length>0&&!hideACtionBar">

									<div v-if="!isSearchPage">

										<span 
											class="action-button"
											v-html="'Track ' + tableItemSelectedProcessed.keywords.length + ' keyword' + ( tableItemSelectedProcessed.keywords.length > 1 ? 's' : '' )"
											@click="showKeywordModal=true"
											v-if="tableItemSelectedProcessed._ids.length>0"
										/>

										<span 
											class="action-button"
											v-html="'Investigate ' + tableItemSelectedProcessed._ids.length + ' keyword' + ( tableItemSelectedProcessed._ids.length > 1 ? 's' : '' )"
											@click="investigate()"
										/>

										<span 
											class="action-button"
											v-html="'Hide ' + tableItemSelectedProcessed._ids.length + ' keyword' + ( tableItemSelectedProcessed._ids.length > 1 ? 's' : '' ) + ' from export'"
											@click="hideSelectedKeywords()"
										/>

									</div>

									<div v-if="isSearchPage && tableItemSelectedProcessed._ids.length>0">

										<span 
											class="action-button"
											v-html="'Link to a Project(s)'"
											@click="showAssignProjectModal()"
										/>

										<span 
											class="action-button"
											v-html="'Delete ' + tableItemSelectedProcessed._ids.length + ' Keyword' + ( tableItemSelectedProcessed._ids.length > 1 ? 's' : '' )"
											@click="deleteAll( { _id: tableItemSelectedProcessed._ids.join(',') } )"
										/>

									</div>

								</ActionsBar>

								<Investigate
									v-if="showInvestigate"
									:theInvestigations="investigations"
									:type="'content-keywords'"
									:project="project"
									@close="closeInvestigateModal"
								/>

								<Keywords 
									v-if="showKeywordModal" 
									@close="closeKeywordModal"
									:internal="true"
									:project="projectsAssigned"
									:keywords="tableItemSelectedProcessed.keywords"
									:meta="tableItemSelectedProcessed.meta"
								/>

								<AssignProjects
									v-if="showProjectModal"
									:ids="tableItemSelected"
									:type="pageType"
									@close="closeAssignProjects"
								/>

							</div>

						</div>

					</div>

				</div>

				<Loading v-if="loadingText!==''" position="inner" :text="loadingText" />

			</div>

		</section>

		<ContentHeadingIdeas
			v-if="showContentHeadingIdeas"
			:info="showContentHeadingIdeas"
			:type="showContentHeadingIdeasType"
			@close="closeContentHeadingIdeas"
			@refresh="fetchKeywords"
		/>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex'
import ApiService from '../services/api.service'
import general from '../utils/general'
import Table from '../components/Table.vue'
import TableGraph from '../components/Display/TableGraph.vue'
import SearchBox from './../components/KeywordDomainAnalysis/SearchBox.vue'
import TopMenu from './../components/KeywordDomainAnalysis/TopMenu.vue'
import AutoSuggest from './../components/KeywordDomainAnalysis/AutoSuggest.vue'
import TopicCluster from './../components/KeywordDomainAnalysis/TopicCluster.vue'
import Backlinks from './../components/KeywordDomainAnalysis/Backlinks.vue'
import TableCPC from './../components/KeywordDomainAnalysis/TableCPC.vue'
import AssignProjects from './../components/KeywordDomainAnalysis/AssignProjects.vue'
import FormInput from './../components/Form/Input.vue'
import IndentList from './../components/Display/IndentList.vue'
import LinkWithIcon from './../components/Display/LinkWithIcon.vue'
import ActionsBar from './../components/Display/ActionsBar.vue'
import Investigate from './../components/Investigate.vue'
import Keywords from './../components/Keywords.vue'
import Loading from './../components/Loading.vue'
import TableButton from './../components/Display/TableButton.vue'
import TableIcon from './../components/Display/TableIcon.vue'
import KeywordStats from './../components/KeywordDomainAnalysis/KeywordStats.vue'
import ContentHeadingIdeas from './../components/KeywordDomainAnalysis/ContentHeadingIdeas.vue'
import Switcher from './../components/Switcher.vue'
import Tip from './../components/Tip.vue'
import PageMessage from './../components/PageMessage.vue'
export default {
	name: 'KeywordDomainAnalysis',
	components: {
		Table,
		SearchBox,
		FormInput,
		PageMessage,
		IndentList, 
		ActionsBar,
		LinkWithIcon,
		TopMenu,
		AutoSuggest,
		Investigate,
		Keywords,
		Backlinks,
		TableCPC,
		Loading,
		AssignProjects,
		KeywordStats,
		Switcher,
		ContentHeadingIdeas,
		Tip,
		TopicCluster
	},
	data() {
		return {
			multipleKeywords: false,
			table: {
				page: 1,
				sorted: { avgMonthlySearches: -1 },
				search: {},
				loading: true,
				items: []
			},
			showContentHeadingIdeas: false,
			showHidden: false,
			loadingText: "",
			reloadKey: 0,
			showKeywordModal: false,
			showInvestigate: false,
			investigations: [],
			searchBoxKey: 0,
			hideFromExport: {},
			countries: [],
			tableKey: 0,
			languages: [],
			keywordsFetched: false,
			keywords: [],
			tableItemSelected: [],
			googleURL: '',
			tabs: [],
			initialLoad: false,
			searchKeyword: '',
			searchCountry: null,
			searchLanguage: null,
			showProjectModal: false,
			filters: null,
			selectedFilters: {},
			searchFilters: {},
			paaAll: [],
			projectsAssigned: [],
			autoAll: [],
			easyAll: [],
			topicalClusterIdeasAll: [],
			list: {},
			project: null,
			checkTimeout: null,
			tasks: [],
			'content-ideas': null,
			'to-improve': null,
			triggerNewSearch: false,
			creatingReport: false,
			hideACtionBar: false,
			comparisons: {},
			fields: {},
			tableSorted: {},
			matchTypeCounts: {},
			newSearchFixed: false,
			termCounts: [],
			termCountsSelected: [],
			getListTimeout: 0,
			highlighted: -1,
			oneClick: false,
			showContentHeadingIdeasType: '',
			access: {},
			onTheCaseTimeout: null,
			workingStatuses: ['pending','in-progress','error'],
			showOnTheCaseEmailButton: false,
			preSearchFilters: {},
		}
	},
	watch: {
		showStillProcessing: {

			handler(to, from) {

				this.okForTips ();

			}

		},
        selectedFilters: {
			deep: true,
			handler(to, from) {
				
				if ( this.initialLoad ) {
					this.fetchKeywords ();
				}
			}
        },
		oneClick: {
			handler(to, from) {
				this.getList ();
			}
		},
		analysisCredits: {
			handler(to, from) {
				if ( this.analysisCredits === 0 && this.oneClick ) {
					this.oneClick = false;
					this.getList ();
				}
			}
		},
		tabStatus: {
			handler(to, from) {
				
				if ( this.workingStatuses.indexOf(to)>=0 && this.workingStatuses.indexOf(from)<0 ) {

					this.onTheCaseTimeout = setTimeout ( function () {

						this.showOnTheCaseEmailButton = true;

					}.bind(this), 10000);

				}

			}
		},
		hideFromExport: {
			deep: true,
			handler(to, from) {

				Object.keys(this.hideFromExport).forEach ( function (tabId) {

					const tabIndex = this.tabs.findIndex( t => t._id.toString() === tabId.toString() )

					if ( tabIndex >= 0 ) {

						this.tabs[tabIndex].hide = !!this.hideFromExport[tabId];

					}
					else {

						this.tabs.forEach ( function (tab,tabIndex) {

							const subTabIndex = tab.subTabs.findIndex( t => !t.default && t._id.toString() === tabId.toString() );

							if ( subTabIndex >= 0 ) {

								this.tabs[tabIndex].subTabs[subTabIndex].hide = !!this.hideFromExport[tabId];

							}

						}.bind(this));

					}

				}.bind(this));

				this.saveSettings ( null, 'hideFromExport' );

			}
        },
		pageName (to,from) {

			if ( to !== from ) this.resetPage ();

		},
		paa: {
			handler(to, from) {

				let daysOld = 3 * 60 * 60 * 24 * 1000;
				
				if ( this.hasPaaResults && this.tabStatus == 'complete' && this.paa.lastKeyChecked && this.highlighted < 0 && new Date( this.paa.checked ).getTime() > daysOld ) this.highlighted = this.paa.lastKeyChecked;

			},
			deep: true
		},
		analysisCreditsAllowed: {
			handler(to, from) {

				this.setup();

			},
			deep: true
		},
		$route: {
			handler(to, from) {
				
				++this.searchBoxKey;

				this.clearTO (true);
				this.showOnTheCaseEmailButton = false;

				Vue.set(this,'tableItemSelected',[]);
				
				switch ( this.filter ) {

					case 'all' :
					case 'overview' :
					case 'questions' :
					case 'popular' :
					case 'easy' :
					case 'content-ideas' : 
					case 'to-improve' : 
					case 'topic-cluster' : 
						
						this.filters = null;
						this.termCounts = [];
						Vue.set( this, 'selectedFilters', {} );
						Vue.set( this.selectedFilters, this.filter, [] );
						this.pagination({page:1});
						++this.tableKey;

					break;

				}

				this.periodicalCheck();

			}
        }
    },
	computed: {

		...mapState('general',['tableSortingInfo','projectList','projectListLoaded','dateTimeFormat','analysisCredits','fullMenu','analysisCreditsAllowed','analysisCreditsAccess']),

		readOnly () {

			return this.analysisCreditsAccess.shared && this.analysisCreditsAccess.readOnly;

		},

		runSearchBox () {

			let description = '', dropdown = {};

			if ( !this.readOnly ) {

				if ( this.filter==='to-improve' ) {

					description = 'Please select a project that has search console connected to it.';
					dropdown = { options: this.projects, placeholder: 'Projects', value: this.project, error: 'select a project' };

				}

				if ( this.filter==='topic-cluster' ) {

					description = 'How many results would you like in your cluster?';

					if ( this.paaAll.length === 0 ) {

						description += '<br>(You may get better results if you run the People Also Ask feature first)';

					}

					dropdown = { options: [ { _id: 10, label: '10 results' },{ _id: 30, label: '30 results' },{ _id: 50, label: '50 results' } ], placeholder: 'Quantity', value: 10, error: 'select an amount' };

				}

			}

			return {
				description: description,
				dropdown: dropdown
			}

		},

		onTheCase () {

			return this.workingStatuses.indexOf(this.tabStatus)>=0;

		},

		oneClickAllowed () {

			return this.analysisCredits > 0 && !this.readOnly;

		},

		toImproveCount () {

			if ( this['to-improve'] && this['to-improve'].count ) return this['to-improve'].count;

			return 0;

		},

		searchMultiple () {

			if ( this.tableName === 'content-keywords--search' ) return false;

			return true;

		},

		isAdmin () {

			return general.isAdmin();

		},

		allowedAccess () {
			
			return this.analysisCreditsAccess.keywords ? this.analysisCreditsAccess.keywords : false;

		},

		isTrial () {
			
			return !!this.analysisCreditsAccess.trial;

		},

		tableName () {

			return 'content-keywords--' + ( this.tabId || 'search' );

		},

		showBacklinks () {

			return this.pageType === 'domain' && this.tab && ['referring-domains','backlinks'].indexOf( this.tab.type ) >= 0;

		},

		showStats () {

			return this.$route.name === 'content-and-keywords-stats';

		},

		sideMenu () {

			return this.pageType !== 'keyword';

		},

		showExportFilter () {

			return !this.isSearchPage&&this.initialLoad&&['complete'].indexOf(this.tabStatus)>=0&&this.filtersProcessed.length>0;

		},

		tableItemSelectedProcessed () {

			let ids = [], keywords = [], meta = { keywordIdeaMD5Key: this.md5Key };

			this.tableItemSelected.forEach ( function (kId) {

				let k = this.resultsTable.items.find( kw => kw._id.toString() === kId.toString() );

				if ( typeof k !== 'undefined' ) {

					let kw = k.keyword;

					if ( typeof kw === 'object' ) {

						kw = kw.label;

					}

					ids.push( this.isSearchPage ? kId : kw );
					keywords.push( k.keyword.label );

				}

			}.bind(this));

			return { _ids: ids, keywords: keywords, meta: meta };

		},

		allStatus () {

			let task = this.tasks.find( t => t.type === 'ideas2' );

			if ( task ) {

				return task.status;

			}

			task = this.tasks.find( t => t.type === 'ideas' );

			if ( task ) {

				return task.status;

			}

			return'pending';

		},

		showStillProcessing () {

			if ( this.filter === 'overview' ) {

				const task = this.tasks.find( t => t.type === 'ideas' );

				return task && task.status === 'complete' && this.allStatus !== 'complete';

			}

			return false;

		},

		notifyTaskStatus () {

			if ( this.actualTabId && this.tasks ) {

				const task = this.tasks.find( t => t.tabId === this.actualTabId );

				if ( task ) {

					return !!task.notify;

				}

			}

			return false;

		},

		topicalClusterIdeas () {

			return this.topicalClusterIdeasAll || null;

		},

		paa () {

			if ( this.tabId && this.paaAll ) {

				let p = this.paaAll.find( p => p.tabId.toString() === this.tabId );

				return p || null;

			}

			return null;

		},

		easy () {

			if ( this.tabId && this.easyAll ) {

				let p = this.easyAll.find( e => e.tabId.toString() === this.tabId );

				return p || null;

			}

			return null;

		},

		hasEasy () {

			return this.easy && this.easy.tabId;

		},

		auto () {

			if ( this.tabId ) {

				let p = this.autoAll.find( p => p.tabId.toString() === this.tabId );

				return p || null;

			}

			return null;

		},

		tabStatus () {

			if ( this.tab ) {

				let tabId = this.tabId;

				if ( this.tab.type === 'topic-cluster' && !!this.subTabId ) tabId = this.subTabId;

				if ( ['all','ideas','questions','popular'].indexOf( this.tab.type ) >= 0 ) return this.allStatus;

				const task = this.tasks.find( t => t.tabId === tabId );

				if ( task ) {

					return task.status;

				}

				switch ( this.tab.type ) {

					case 'paa' : if ( this.paa && this.paa.results && this.paa.results.length > 0 ) return 'complete'; break;
					case 'auto' : if ( this.auto && this.auto.results && this.auto.checked ) return 'complete'; break;
					case 'content-ideas' : if ( this['content-ideas'] && this['content-ideas'].checked ) return 'complete'; break;
					case 'easy' : if ( this.hasEasy ) return 'complete'; break;

				}

			}

			let rtn = 'none';
			
			if ( this.actualTabId === 'stats' ) {

				this.tabs.forEach ( function (tab) {

					if ( !!tab.stats && !!tab.stats.status && tab.stats.status === 'in-progress' ) {

						rtn = 'in-progress';

					}

				}.bind(this));

			}

			return rtn;

		},

		tableMeta () {

			return {};

		},

		tabId () {
			
			return this.showStats ? 'stats' :  this.$route.params.tabId;

		},

		tab () {

			if ( this.tabs ) {

				return this.tabs.find( t => t._id.toString() === this.tabId );

			}

			return null;

		},

		pendingTitle () {

			if ( this.tab ) {

				if ( this.tabStatus === 'error' ) {

					switch ( this.tab.type ) {

						case 'all' :
						case 'ideas' : 
							return "There was an error getting your keywords";
						default:
							return "There was an error";

					}

				}

				switch ( this.tab.type ) {

					case 'all' :
					case 'ideas' : 
						return "Your Keywords Are Being Checked...";
					default:
						return "We Are On The Case!";

				}

			}

		},

		pendingInfo () {

			if ( this.tab ) {

				if ( this.tabStatus === 'error' ) {

					return "Some kind of error stopped us from being able to get your " + this.tabTypeLabel + ", please click the button to try again, if this happens again please get in touch with us (<strong>your analysis credits have been returned</strong>).";

				}

				switch ( this.tab.type ) {

					case 'all' :
					case 'overview' :
					case 'questions' :
					case 'popular' :
					case 'ideas' : return "We are grabbing your keywords. This page will display them automatically when they are ready.";
					case 'paa' : return "Your People Also Ask Results are being put together now, this page will display them automatically when they are ready.";
					case 'auto' : return "Your Auto-Suggest Results are being put together now, this page will display them automatically when they are ready.";
					case 'easy' : return "Your Easy Keywords are being put together now, this page will display them automatically when they are ready. This one requires quite a bit of work so you may want to check back in a while.";
					case 'content-ideas' : return "Your Supporting Content Ideas are being put together now, this page will display them automatically when they are ready.";
					case 'to-improve' : return "Your Keywords To Improve are being put together now, this page will display them automatically when they are ready.";
					case 'topic-cluster' : return "Your Topic Cluster is being put together now, this page will display them automatically when they are ready.";

				}

			}

		},

		md5Key () {

			return this.$route.params.key;

		},

		tabSearchFilters () {

			return this.searchFilters[this.actualTabId] || [];

		},

		searchDescription () {

			return "Click the operators to toggle (e.g. contains, equals etc.)<br>To add multiple keywords to the same field, separated with 2 pipes (e.g. keyword 1||keyword 2||keyword 3)";

		},

		projects () {

			let projects = [];

			this.projectList.forEach ( function (project) {

				projects.push( { _id: project._id, label: project.name } );

			});

			return projects;

		},

		hasPaaResults () {

			return this.filter === 'paa' && this.paa && this.paa.checked;

		},

		isCheckingPAAChild () {

			if ( this.hasPaaResults && ( this.tabStatus == 'pending' || this.tabStatus === 'in-progress' ) ) {

				let task = this.tasks.find( t => t.tabId === this.tabId );

				if ( task && task.meta && task.meta.keywordKeys && task.meta.keywordKeys,length > 0 ) return task.meta.keywordKeys.slice(-1)[0];

			}
			
			return false;

		},

        showResults () {

			if ( this.hasPaaResults ) {

				return true;

			}

			if ( this.tabStatus !== 'none' && this.tabStatus !== 'complete' ) return false;

			if ( this.filter === 'easy' ) {

				return this.hasEasy;

			}

            if ( !this.isSearchPage ) {

				if ( ['auto','content-ideas','to-improve'].indexOf(this.filter) >= 0 )  {
					
					return !!this[this.filter] && Object.keys( this[this.filter] ).length > 0;

				}

                return true;

            }
			else { // If has list of keyword searches already

				return this.resultsTable.countTotal > 0;

			}

            return false;

        },

		subMenu() {

			let menuItems = [];

            if ( this.filter === 'content-ideas' && this['content-ideas'].domains ) {

				this['content-ideas'].domains.forEach ( function (domain) {

					let hide = this.subTabId || 'default';

					hide = ( domain.hide && domain.hide[hide] );

					menuItems.push({ label: domain.domain, _id: domain._id, position: domain.position, selected: domain._id === this['content-ideas'].selected, hide: hide });

				}.bind(this));

            }

            return menuItems;

        },

		resultsTable () {

			if ( this.isSearchPage ) {

				return this.list;

			}

			switch ( this.filter ) {

				case 'content-ideas' :

					return this['content-ideas'].ideas;

				break;

				case 'to-improve' :

					return this['to-improve'];

				break;

				default :

					return this.table;

			}

		},

		runBoxTitle () {

			let action = this.tabStatus === 'error' ? 'retry' : 'view';

			if ( this.filter === 'topic-cluster' ) {

				action = this.tabStatus === 'error' ? 'retry your' : 'generate your';

			}

			if ( this.readOnly ) return 'You do not have permission to run this feature';

			switch ( this.filter ) {

				case 'paa' : return 'Click to '+action+' '+this.tabTypeLabel+' keywords';
				case 'auto' : return 'Click to '+action+' '+this.tabTypeLabel+' keywords';
				case 'easy' : return 'Click to '+action+' '+this.tabTypeLabel;
				case 'content-ideas' : return 'Click to '+action+' '+this.tabTypeLabel;
				case 'to-improve' : return 'Click to '+action+' '+this.tabTypeLabel;
				case 'topic-cluster' : return 'Click to '+action+' '+this.tabTypeLabel;

			}

		},

		tabTypeLabel () {

			switch ( this.filter ) {

				case 'all' :
				case 'overview' :
				case 'ideas' :
				case 'ideas2' : return 'Keyword Ideas';
				case 'paa' : return 'People Also Ask';
				case 'auto' : return 'Auto-Suggest';
				case 'easy' : return 'Easy Keywords';
				case 'content-ideas' : return 'Supporting Content Ideas';
				case 'to-improve' : return 'Keywords To Improve';
				case 'topic-cluster' : return 'Topic Cluster';

			}

		},

		resultType () {

			if ( ['auto','paa','topic-cluster'].indexOf(this.filter) >= 0 ) return this.filter;

			if ( this.isSearchPage && !this.showResults ) return 'search';

			return 'table';

		},

		toImproveMessage () {

			if ( this.filter === 'to-improve' && this.projects.length < 1 ) {

				if ( this.projectListLoaded ) {

					return 'You need to create a project and connect it to Google Search Console to use this feature.';

				}
				
				return 'Loading projects...';

			}

			return ''

		},

		showRunBox () {

			if ( this.tabStatus !== 'none' ) return false;

			if ( this.filter === 'to-improve' && this.projects.length < 1 ) return false;

			if ( this.tab && this.tabStatus === 'error' && ['paa','auto','easy','content-ideas','ideas'].indexOf( this.tab.type ) >= 0 ) return false;

			if ( this.filter === 'easy' ) {

				return !this.hasEasy;

			}

			if ( this.filter === 'topic-cluster' ) {

				return this.topicalClusterIdeasAll;

			}

			let atLeast = this.filter === 'paa' ? 2 : 1;

			if ( ['auto','paa','content-ideas','to-improve'].indexOf(this.filter) >= 0 )  {

				return !( this[this.filter] && Object.keys( this[this.filter] ).length > atLeast );

			}

			return false;

		},

		showMainTitle () {

			return !!this.searchBoxTitle;

			//if ( this.tabStatus==='complete' || this.hasPaaResults ) return true;

			if ( !this.showRunBox ) return true;

			if ( this.actualTabId === 'stats' ) return true;

			return false;		

		},

        searchBoxTitle () {

			if ( this.isSearchPage ) {

				if ( this.resultsTable.countTotal > 0 ) return '';

				switch ( this.pageName ) {

					case 'content-and-keywords': return "Search By Keyword";
					case 'website-analysis': return "Search By Domain/URL";

				}

			}

        	let r = [this.searchKeyword];

			if ( this.searchCountry && this.countries ) {

				let country = this.countries.find( c => c._id === this.searchCountry );

				if ( country ) r.push(country.label);

			}

			if ( this.searchLanguage && this.languages ) {

				let language = this.languages.find( c => c._id === this.searchLanguage );

				if ( language ) r.push(language.label);

			}

			return r.join(' - ');

        },

		searchBoxDescription () {
			return '';
			if ( this.isSearchPage && !this.resultsTable.count ) {

				switch ( this.pageName ) {

					case 'content-and-keywords': return "Search info about searching by keyword";
					case 'website-analysis': return "Search info about searching by domain";

				}

			}

			return '';

		},

		searchBoxFormInput () {

			switch ( this.pageName ) {

				case 'content-and-keywords': return {type:this.multipleKeywords?'textarea':'text',placeholder:'Keyword', value: this.searchKeyword };
				case 'website-analysis': return {type:'url',placeholder:'Domain or URL', value: this.searchKeyword };

			}

			return {};

		},

		searchBoxDropdown () {

			switch ( this.pageName ) {

				case 'content-and-keywords': 
				case 'website-analysis': 
					return { options: this.countries, placeholder: 'Country', value: this.searchCountry, error: 'select a country' };

			}

			return {};

		},

		searchBoxDropdown2 () {

			switch ( this.pageName ) {

				case 'content-and-keywords': 
				case 'website-analysis': 
					return { options: this.languages, placeholder: 'Language (ignore to use default)', value: this.searchLanguage, error: 'select a language' };

			}

			return {};

		},

		emptyTableLabel () {

			let r = 'No keywords found';

			if ( this.filter === 'popular' ) r += ' for the selected popular filters';
			if ( this.filter === 'questions' ) r += ' for the selected questions';
			if ( this.filter === 'easy' ) r = 'No easy keywords found';
			if ( this.filter === 'content-ideas' ) r = 'No ideas found for this domain';

			return r;

		},

		filter () {

			return this.tab ? this.tab.type : null;

		},

		filtersProcessed () {

			let filters = [];

			if ( this.filter && this.filters && this.filters[this.filter] ) {

				if ( this.filter === 'overview' ) {

					let filterInfo = {
						exact: { label: "Exact Term", tip: "Keywords that contain the exact match term you are researching." },
						contains: { label: "Contains Term Words", tip: "Keywords that contain words from the term you are researching. This may not be all the words and it may not be in the exact order." },
						related: { label: "Related Terms", tip: "All other terms (not containing part or all of the term you are researching)" }
					};

					['exact','contains','related'].forEach ( function (n) {

						if ( this.filters[this.filter].indexOf(n) >= 0 ) {

							filters.push( { _id: n, label: filterInfo[n].label + ' (' + this.matchTypeCounts[n] + ')', disabled: this.selectedFilters[this.filter].length === 1 && n === this.selectedFilters[this.filter][0] } );

						}

					}.bind(this));

				}
				else {

					this.filters[this.filter].forEach( function (filter) {

						filters.push( { _id: filter, label: general.capitalizeFirstLetter( filter ), disabled: this.selectedFilters[this.filter].length === 1 && filter === this.selectedFilters[this.filter][0] } );

					}.bind(this));

				}

			}

			return filters;

		},

		pageName () {
			
			return this.$route.name.substring(0,16) === 'website-analysis' ?  'website-analysis' : 'content-and-keywords';

		},

		pageType () {

			return this.pageName === 'content-and-keywords' ? 'keyword' : 'domain';

		},

		showTabs () {

			return this.$route.name === 'content-and-keywords' || this.$route.name === 'website-analysis';

		},
		searchPageTitle () {
			
			return this.pageType === 'keyword' ? 'Content & Keywords' : 'Website Analysis';

		},
		isSearchPage () {

			return this.$route.name === 'content-and-keyword-search' || this.$route.name === 'website-analysis-search';

		},
		showSearchBox () {

			return ( ( this.isSearchPage && this.list !== null ) || this.initialLoad ) && this.loadingText === '';

		},

		tips () {

			return {
				overview: "View all keywords in this data set. Within this tab, you can also break the keywords down by common words, exact terms, partial terms and related terms.",
				questions: "All of the questions from your key term data will be filtered in this tab. You can also turn on/off particular question types such as how, what, why etc.",
				popular: "This tab filters the data by selected popular filters such as, benefits, alternative, vs, template, examples, reviews etc.",
				paa: "You have the option of pulling in data from Google's People Also Ask feature. 3 levels are pulled in by default, with the option to pull in more for relevant questions. Note: this feature uses Analysis Credits.",
				auto: "You have the option of pulling in data from Google's Auto-Suggest feature. Note: this feature uses Analysis Credits.",
				'content-ideas': "This feature analyses the top ranking sites and displays the supporting content they have written around your topic. Great for idea generation. Note: this feature uses Analysis Credits.",
				'topic-cluster': "This feature combines your keyword research data with AI to generated a topic cluster around your keyword.",
				'to-improve': "You may already be ranking for a number of the keywords in this data set. The 'To Improve' feature allows you to filter these keywords into this tab by comparing with Google Search Console data. You must have an active project to be able to use this feature."
			};

		},

		tableHeadings () {

			let c = this.resultsTable.loading ? '' : ( this.resultsTable.count > 0 ? ( ' (' + this.resultsTable.count + ')' ) : '' );

			if ( !this.filter && !this.isSearchPage ) return {};

			if ( this.filter === 'to-improve' ) {

				return {
					c: { value: 'Select', checkBox: true, checkBoxVar: '_id' },
					keyword: { value: 'Keywords'+c, sort: 1, component: LinkWithIcon, event: 'selectKeyword', 'clickVars': ['_id','keyword','label'] },
					url: { value: 'URL', emptyCell: 'N/A', component: LinkWithIcon },
					avgMonthlySearches: { value: 'Search Vol.', emptyCell: 'Unknown', sort: -1, styles: "width:140px" },
					clicks90: { value: 'Clicks', sort: 1, emptyCell: '0', forFilter: true, gsc: true },
					ctr90: { value: 'CTR %', sort: -1, emptyCell: '0', forFilter: true, gsc: true },
					impressions90: { value: 'Impressions', sort: -1, emptyCell: '0', forFilter: true, gsc: true },
					position90: { value: 'Avg Pos.', sort: 1, emptyCell: 'None', forFilter: true, gsc: true },
					currentPosition: { value: 'Cur. Pos.', emptyCell: 'N/A', forFilter: true, rc: true },
					serp: { value: '', emptyCell: 'N/A', component: LinkWithIcon }
				};

			}

			if ( this.filter === 'content-ideas' ) {

				return {

					title: { value: 'Title', sort: 1 },
					url: { value: 'URL', component: LinkWithIcon }

				}

			}

			if ( this.isSearchPage ) {

				return {
					c: { value: 'Select', checkBox: true, checkBoxVar: '_id' },
					keyword: { value: this.pageType === 'domain' ? 'Domain' : 'Keyword', sort: 1, component: LinkWithIcon, event: 'clicked' },
					country: { value: 'Country' },
					language: { value: 'Language', emptyCell: 'Default' },
					overview: { value: 'Ideas', component: TableButton, tip: this.tips['overview'] },
					questions: { value: 'Questions', component: TableButton, tip: this.tips['questions'] },
					popular: { value: 'Popular', component: TableButton, tip: this.tips['popular'] },
					paa: { value: 'PAA', component: TableButton, event: this.oneClick ? 'oneClick' : null, tip: this.tips['paa'] },
					auto: { value: 'Auto-Suggest', component: TableButton, event: this.oneClick ? 'oneClick' : null, tip: this.tips['auto'] },
					'content-ideas': { value: 'Cont. Ideas', component: TableButton, event: this.oneClick ? 'oneClick' : null, tip: this.tips['content-ideas'] },
					'topic-cluster': { value: 'Topic Cluster', component: TableButton, event: null, tip: this.tips['topic-cluster'] },
					'to-improve': { value: 'To Improve', component: TableButton, event: this.oneClick ? 'oneClick' : null, tip: this.tips['to-improve'] },
					created: { value: 'Created', emptyCell: 'Default', sort: -1, dateFormat: this.dateTimeFormat },
					projects: this.readOnly ? { value: 'Project(s)', emptyCell: 'None assigned'} : { value: 'Project(s)', emptyCell: 'None assigned', click: 'showAssignProjectModal', clickVars: ['_id'] },
					delete: { value: '', valueForFilter: 'Delete', component: TableIcon, event: 'deleteAll', hide: true }
				}

			}

			let th = {
				c: { value: 'Select', checkBox: true, checkBoxVar: '_id' },
				keyword: { value: 'Keywords'+c, sort: 1, component: LinkWithIcon, event: 'selectKeyword', 'clickVars': ['_id','keyword','label']  },
				searches: { value: '12 month AVG', component: TableGraph, styles: "width:170px" },
				avgMonthlySearches: { value: 'Search Vol.', emptyCell: 'Unknown', sort: -1, styles: "width:140px" },
				avg_cpc: { value: 'AVG CPC', emptyCell: 'Unknown', component: TableCPC, sort: -1, styles: "width:140px" },
				competition: { value: 'CPC Comp', emptyCell: 'Unknown', sort: -1, styles: "width:140px" },
				serp: { value: '', emptyCell: 'N/A', component: LinkWithIcon, styles: "width:100px" },
				add: { value: '', emptyCell: 'Tracked', component: TableButton, event: 'trackKeyword', hide: this.readOnly }
			}

			if ( this.readOnly ) delete th.add;

			return th;

		},

		queryString () {

			let queryString = '?', 
				table = this.currentTable ();
				
			queryString += 'sortBy=' + this.sorting.sortBy + '&sortDir=' + this.sorting.sortDir;

			if ( table.page ) queryString += '&page=' + table.page;

			if ( this.oneClick && this.isSearchPage ) queryString += '&oneClick=1';

			if ( table.search ) {

				Object.keys(table.search).forEach( function (n) {

					if ( table.search[n] ) {

						if ( n === 'created' ) {

							Object.keys( table.search[n] ).forEach( function (c) {

								queryString += '&created-'+c+'=' + table.search[n][c].getTime();

							});

						}
						else {

							queryString += '&'+n+'=' + table.search[n];

						}

					}

				}.bind(this));

			}

			if ( this.filter === 'overview' ) {

				let t = [];

				this.termCountsSelected.forEach ( function (terms) {

					t.push( terms.join('|') );

				});

				if ( t.length > 0 ) queryString += '&words=' + t.join(',');

			}

			if ( ( this.filter === 'popular' || this.filter === 'questions' || this.filter === 'overview' ) && this.selectedFilters[this.filter] ) {

				if ( this.initialLoad ) 
					queryString += '&startsWith=' + this.selectedFilters[this.filter].join(',');
				else 
					queryString += '&filter='+this.filter;

			}

			return queryString;

		},

		sorting () {

			let table = this.currentTable (),
				sorted;
				
			if ( this.tableName && !this.tableSorted[this.tableName] && this.tableSortingInfo[this.tableName] ) {

				sorted = this.tableSortingInfo[this.tableName];
				table.sorted = sorted;

			}
			else {

				sorted = table.sorted;

			}

			if ( sorted ) {

				let sortBy = Object.keys(sorted)[0] || '',
				sortDir = sorted[sortBy] === 1 ? 'asc' : 'desc';

				return { sortBy: sortBy, sortDir: sortDir }

			}

			return { sortBy: '', sortDir: '' };

		},
		searchSetup() {

			if ( this.filter === 'content-ideas' ) return {};

			if ( this.isSearchPage && this.projectListLoaded ) {

				let searchSetup = { 
					keyword: { type: 'text', placeholder: '', showLabel: 'Keyword' },
					country: { 
						type: 'select', 
						multi: true, 
						showLabel: 'Country', 
						items: this.countries
					},
					language: { 
						type: 'select', 
						multi: true, 
						showLabel: 'Language', 
						items: this.languages
					},
					projects: {
						type: 'select',
						multi: true,
						showLabel: 'Project(s)',
						items: general.listProjects ( this.projectList )
					},
					created: { 
						type: 'date-range', 
						placeholder: '', 
						showLabel: 'Created' 
					}
				};

				if ( searchSetup.projects.items.length < 1 ) {

					delete searchSetup.projects;

				}

				Object.keys( this.preSearchFilters ).forEach ( function (f) {

					if ( searchSetup[f] ) {

						searchSetup[f].values = this.preSearchFilters[f];

					}

				}.bind(this));

				return searchSetup;

			}

			let filters = {};

			Object.keys( this.fields ).forEach ( function ( f ) {

				if ( this.fields[f].types.indexOf(this.filter) >= 0 && this.fields[f].placements.indexOf('filters') >= 0 ) {

					filters[f] = general.stripObject ( this.fields[f].searchVars );

					let group = null;

					if ( filters[f].group ) {

						if ( typeof filters[f].group === 'object' ) {

							if ( filters[f].group[this.filter] ) group = filters[f].group[this.filter];

						}
						else {

							group = filters[f].group;

						}

						if ( group ) 
							filters[f].group = group;
						else 
							delete filters[f].group;

					}

				}

			}.bind(this));

			return filters;

		},
		subTabs () {

			if ( this.tab && this.tab.subTabs ) return this.tab.subTabs;

			return [];

		},
		actualTab () {

			if ( this.tab && this.subTabId ) {

				return this.subTabs.find( subTab => !subTab.default && subTab._id.toString() === this.subTabId );

			}

			return this.tab;

		},
		subTabId () {

			return this.$route.params.subTabId || null;

		},
		actualTabId () {

			return this.subTabId || this.tabId;

		},
		showSubTabs () {

			if ( this.tab && this.tab.type === 'topic-cluster' && !!this.subTabId ) return true;

			if ( this.showRunBox ) return false;

			if ( this.md5Key && this.allStatus==='complete' && this.tab ) {

				return ['overview','questions','popular','paa','auto','content-ideas','topic-cluster'].indexOf(this.tab.type) >= 0;

			}

			return false;

		},
		apiURL () {

			return 'googlea/';

		},
		toImproveProject () {

			if ( this.tabStatus === 'complete' && this.filter === 'to-improve' && this.actualTab.meta && this.actualTab.meta.projectId ) {

				let project = this.projectList.find( p => p._id.toString() === this.actualTab.meta.projectId.toString() );

				if ( project ) return project.name;

			}

			return null;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText','updateVar','reloadInstructionalTips']),

		okForTips () {

			let ok = !this.showStillProcessing;

			this.updateVar( { varName:'instructionalTipsHide', info: !ok } ); 

		},

		tableMounted () {

			this.reloadInstructionalTips();

		},

		watchVideo () {

			this.updateVar( { varName:'playVideo', info: 'content-and-keywords' } ); 
			this.updateVar( { varName:'showVideos', info: true } ); 

		},

		deleteAll ({_id,name}) {

			let msg = 'Are you sure';

			if ( name ) msg += ' you want to delete '+name;
			
			this.$dialog
				.confirm( msg+"?", { okText: 'Yes', cancelText: 'Cancel'})
				.then(function() {

					this.loading ();

					ApiService.delete( this.apiURL + 'delete-all/' + _id )
					.then( function() {

						this.fetchKeywords ();

					}.bind(this))
					.catch( function(err) {}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		clearToImprove () {

			this.$dialog
				.confirm( "Are you sure?", { okText: 'Yes', cancelText: 'Cancel'})
				.then(function() {

					ApiService.delete( this.apiURL + 'to-improve/' + this.md5Key + '/' + this.tabId )
					.then( function() {

						this['to-improve'] = {};

						this.fetchKeywords ();

					}.bind(this))
					.catch( function(err) {}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		oneClickAnalysis (info) {

			let extraInfo = {};

			if ( info.tabType === 'to-improve' ) {

				if ( !info.project ) {

					this.$snotify.success( "You need to add a project to run To Improve, click 'None assigned' in the Project column to add one", 'One Click Analysis');
					return;

				}

				extraInfo.dropdown = info.project;

			}

			this.submitSecondary ( extraInfo, null, null, info.md5Key, info.tabType, info._id );

		},

		keywordContentIdeas (a) {

			this.showContentHeadingIdeasType = 'contentTitleIdeas';
			this.showContentHeadingIdeas = a.contentTitleIdeas;

		},

		closeContentHeadingIdeas () {

			this.showContentHeadingIdeas = false;

			general.modalClose();

		},

		processTabs (response) {

			if ( response.data.tabs ) {

				this.tabs = response.data.tabs;

				if ( Object.keys(this.hideFromExport).length === 0 ) {

					this.tabs.forEach ( function (tab) {

						Vue.set( this.hideFromExport, tab._id, !!tab.hide );

						tab.subTabs.forEach( function ( subTab ) {

							if ( subTab.default ) return;

							Vue.set( this.hideFromExport, subTab._id, !!subTab.hide );

						}.bind(this));

					}.bind(this));

				}

			}

		},

		newTab () {

			let runIt = function () {

				this.loading();

				ApiService.post( this.apiURL + 'keyword-ideas/tab/' + this.md5Key + '/' + this.tabId )
				.then( function(response) {

					this.processTabs (response);

					let s = this.tab.subTabs[this.tab.subTabs.length-1];

					this.loading(null,true);

					this.$router.push('/content-and-keywords/'+this.filter+'/'+this.md5Key+'/'+this.tabId+'/'+s._id);

				}.bind(this))
				.catch( function(err) {}.bind(this));

			}.bind(this);

			if ( this.subTabs.length === 0 ) {

				let msg = this.filter === 'topic-cluster' ? "Add a new tab if you'd like to re-run the topic cluster with a different quantity" : "Adding a new tab allows you add different filters to the same data, this will then appear separately on your export.";

				this.$dialog
					.confirm( msg, { okText: 'Add Tab', cancelText: 'Cancel'})
					.then(function() {

						runIt();

					}.bind(this))
					.catch(function() {});

			}
			else {

				runIt();

			}

		},

		deleteTab () {

			let tabIndex = this.tabs.findIndex( tab => tab._id === this.tabId ),
				t = this.tabs[tabIndex].subTabs.find(t => !t.default && t._id === this.subTabId);

			this.$dialog
				.confirm( "Are you sure you want to delete the tab "+t.label+"?", { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					ApiService.delete( this.apiURL + 'keyword-ideas/tab/' + this.md5Key + '/' + this.tabId + '/' + this.subTabId )
					.then( function(response) {

						this.$router.push('/content-and-keywords/'+this.filter+'/' + this.md5Key + '/' + this.tabId);

					}.bind(this))
					.catch( function(err) {}.bind(this));

				}.bind(this))
				.catch(function() {
					

				});

		},

		saveTab ( info ) {
			
			let id = info.tab.default ? 'default' : info.tab._id,
				tabIndex = this.tabs.findIndex( tab => tab._id === this.tabId );

			this.tabs[tabIndex].subTabs[info.index].label = info.label;

			ApiService.post( this.apiURL + 'keyword-ideas/tab/' + this.md5Key + '/' + this.tabId + '/' + id, { label: info.label } )
			.then( function(response) {

				this.processTabs (response);

			}.bind(this))
			.catch( function(err) {}.bind(this));

		},

		checkWordBreakdowns () {

			this.termCountsSelected = [];

			setTimeout( function () { 

				this.termCounts.forEach( function (term,index) {

					let t = [];

					if ( term.checked ) t.push(term.keyword);

					term.related.forEach( function (term2,index2) {

						if ( term2.checked ) {
							
							if ( term.checked ) t.push(term2.keyword);
							else {

								Vue.set( this.termCounts[index].related[index2], 'checked', false );

							}
						}

					}.bind(this));

					if ( t.length > 0 ) this.termCountsSelected.push(t);

				}.bind(this));

				this.saveSettings ( function () {

					this.pagination({page:1});

				}.bind(this),'checkWordBreakdowns');

			}.bind(this), 100)

		},

		goToProjects () {

			this.$router.push('/');

		},

		trackKeyword ({_id}) {

			Vue.set(this,'tableItemSelected',[_id]);
			this.hideACtionBar = true;
			this.showKeywordModal=true;

		},

		keywordActions(ids,hideACtionBar) {
		
			if ( hideACtionBar ) this.hideACtionBar = true;
			Vue.set(this,'tableItemSelected',ids);

		},

		showAssignProjectModal ( info ) {
			
			if ( info && info._id ) this.keywordActions([info._id],true);
			this.showProjectModal = true;

		},

		closeAssignProjects (reload) {

			this.showProjectModal = false;
			this.hideACtionBar = false;

			general.modalClose();

			if ( reload ) this.fetchKeywords ();
			
		},

		loading ( msg, close ) {

			if ( close ) {

				this.loadingText = '';

			}
			else {

				this.loadingText = msg || "One moment...";

			}

		},

		resetPage () {
			
			Vue.set(this,'tableItemSelected',[]);
			++this.reloadKey;

		},

		hideSelectedKeywords () {

			if ( !this.tabSearchFilters ) {

				Vue.set( this.searchFilters, this.actualTabId, [] );

			}

			let info = {
					value: this.tableItemSelectedProcessed.keywords.join('||'),
					comparison: '<>'
				}, 
				multi = false;

			if ( !this.tabSearchFilters || this.tabSearchFilters.length === 0 ) {

				Vue.set( this.searchFilters,this.actualTabId, [{ keyword: info }] );

			}
			else {

				multi = true;

				this.tabSearchFilters.forEach ( function ( searchLine, index ) {

					let s = general.stripObject( searchLine ), 
						n = 1;

					Object.keys( s ).forEach ( function ( searchVar ) {

						if ( searchVar.split('____')[0] === 'keyword' ) ++n;

					}.bind(this));

					s[n > 1 ? ( 'keyword____' + n ) : 'keyword'] = info;

					Vue.set( this.searchFilters[this.actualTabId], index, s );

				}.bind(this));

			}

			const response = multi ? 'A filter has been added to each of your current filter groups, you can undo this by deleting the filters in "Add/edit filter options"' : 'A filter has been added to hide the keywords, you can undo this by deleting the filter in "Add/edit filter options"';
			
			this.$snotify.success(response, 'Hide From Export');

			Vue.set( this, 'tableItemSelected', [] );

			++this.tableKey;

			this.saveSettings ( function () {

				this.fetchKeywords ();

			}.bind(this),'hideSelectedKeywords');

		},

		closeKeywordModal (info) {

			this.showKeywordModal = false;

			this.hideACtionBar = false;

			general.modalClose();

			if ( ( info && info.keywords ) || this.tableItemSelected.length === 1 ) {

				Vue.set(this,'tableItemSelected',[]);

				++this.tableKey;

			}

		},

		investigate (info) {

			this.investigations = [];
			
			let items = typeof info === 'undefined' ? this.tableItemSelectedProcessed._ids : [info];

			items.forEach ( function (id) {

				id = typeof info === 'undefined' ? id : id._id;

				let k = this.resultsTable.items.find( kw => kw._id.toString() === id.toString() );

				if ( k ) {

					let item = { _id: k._id };

					if ( typeof k.keyword !== 'undefined' ) item.keyword = k.keyword;
					if ( typeof k.url !== 'undefined' ) item.url = k.url.link;

					this.investigations.push( item );

				}

			}.bind(this));

			this.showInvestigate = true;

		},

		closeInvestigateModal (info) {

			general.modalClose();

			this.showInvestigate = false;

		},

		resetSearchBox () {

			this.searchKeyword = this.searchKeywordOriginal;
			this.newSearchFixed = false;
			this.triggerNewSearch = false;

		},

		selectKeyword (info) {

			if ( info.action && info.action === 'contentHeadingIdeas' ) {

				this.keywordContentIdeas(info);

			}
			else {

				this.triggerNewSearch = true;
				this.newSearchFixed = true;
				this.searchKeyword = info.label;
				++this.searchBoxKey;

			}

		},

		toggleFilters(allOn) {

			let ids = [];

			this.filtersProcessed.forEach ( function (n) {

				ids.push(n._id);

			});

			if ( allOn ) {

				Vue.set( this.selectedFilters, this.filter, ids );

			}
			else {

				Vue.set( this.selectedFilters, this.filter, [ids[0]] );

			}

		},

		autoSuggestHide( category, type ) {

			if ( type ) category += '.' + type.toLowerCase();

			return this.tab.meta && this.tab.meta.hide && this.tab.meta.hide[category.toLowerCase()];

		},

		tryAgain () {

			this.loading ();

			const task = this.tasks.find( t => t.tabId === this.actualTabId );
			
			ApiService.get( this.apiURL + 'retry/' + task._id )
            .then( function(info) {
				
				//this.getList ();
				this.fetchKeywords ();

            }.bind(this))
            .catch( function(err) {}.bind(this));

		},

		notifyTask (t) {

			this.loading ();

			let uri = this.apiURL + 'task/notify/' + this.md5Key + '/' + this.tabId;

			if ( this.subTabId ) uri += '/' + this.subTabId;

			ApiService.post( uri )
            .then( function(info) {

				this.fetchKeywords ();

            }.bind(this))
            .catch( function(err) {}.bind(this));

		},

		hideAutoSuggest( type, word, hide ) {

			this.loading ();

			ApiService.post( this.apiURL + 'auto/' + this.md5Key + '/' + this.tabId, { hide: hide, type: type, word: word } )
            .then( function(info) {

				this.fetchKeywords ();

            }.bind(this))
            .catch( function(err) {}.bind(this));

		},

		createReport (all) {

			this.creatingReport = true;

			let tabBit = '/' + this.tabId;

			if ( this.subTabId ) tabBit += '/' + this.subTabId;

			let filename = this.searchBoxTitle;

			if ( all ) filename += ' all';
			else filename += ' ' + this.actualTab.label;

			filename += ' rankcaddy export ' + general.dateFormat ('dmy');

			filename = filename.replaceAll(' - ',' ').replaceAll(' ','-').toLowerCase();

			ApiService.get( this.apiURL + 'report/' + this.md5Key + ( !all ? tabBit : '' ), { responseType: 'arraybuffer' } )
            .then( function(info) {

				this.creatingReport = false;

				const blob = new Blob([info.data], { type: info.headers['content-type'], encoding: 'UTF-8' })
				const link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				link.download = filename+'.xlsx';
				link.click();

            }.bind(this))
            .catch( function(err) {

				this.creatingReport = false;
				
			}.bind(this));

		},

		clearTO (all) {

			if ( this.checkTimeout ) clearTimeout( this.checkTimeout );
			this.checkTimeout = null;

			if ( this.getListTimeout ) clearTimeout (this.getListTimeout);
			this.getListTimeout = null;

			if ( all ) {

				if ( this.onTheCaseTimeout ) clearTimeout (this.onTheCaseTimeout);
				this.onTheCaseTimeout = null;

			}

		},

		periodicalCheck () {
			
			this.clearTO ();
			
			if ( ['pending','in-progress'].indexOf(this.tabStatus) >= 0 || this.showStillProcessing || ( this.actualTabId === 'stats' && ['pending','in-progress'].indexOf(this.allStatus) >= 0 ) ) {

				this.checkTimeout = setTimeout(() => {
		
					this.fetchKeywords ( this.showStillProcessing, this.showStillProcessing );

				}, 4000);

				return;

			}

			if ( this.initialLoad && this.tabStatus === 'complete' ) {

				switch ( this.filter ) {

					case 'content-ideas' :

						let domainId = ( this['content-ideas'] && this['content-ideas'].selected ) ? this['content-ideas'].selected : null;

						this.submitSecondary ( null, domainId ? [domainId] : [] );

						return;

					case 'to-improve' :

						this.submitSecondary ();

						return;

				}

			}

		},

		saveSettings ( callback, from ) {

			if ( this.tabId === 'stats' ) return;

			let info = { 
				tabs: this.tabs,
				tableFilters: this.searchFilters,
				subTabId: this.subTabId
			}

			if ( from !== 'hideFromExport' ) info.termCountsSelected = this.termCountsSelected;

			ApiService.post( this.apiURL + 'keyword-ideas/' + this.md5Key + '/' + this.tabId, info )
            .then( function() {

				if ( callback ) {

					callback();

				}

            }.bind(this))
            .catch( function(err) {

            }.bind(this));

		},

		closeSearchMultiple (info) {
			
			Vue.set( this.searchFilters, this.actualTabId, info );

			this.saveSettings ( function () {

				this.fetchKeywords ();

			}.bind(this), 'closeSearchMultiple');

		},

		currentTable () {

			switch ( this.filter ) {

				case 'content-ideas' :

					if ( this['content-ideas'] && this['content-ideas'].ideas ) return this['content-ideas'].ideas;

				break;

			}

			if ( this.isSearchPage ) {
				
				return this.list;

			}
			
			return this.table;

		},

		subMenuItemClick (index) {

			let table = this.currentTable ();

			table.sorted = {};
			table.page = 1;

			this.submitSecondary ( null, [this['content-ideas'].domains[index]._id] );

		},

		hideContentIdeas ( ev, _id, hide ) {

			ev.stopPropagation();

			this.loading ('One moment...');

			let uri = this.apiURL + 'content-ideas/hide/' + this.md5Key + '/' + this.tabId;

			if ( this.subTabId ) uri += '/' + this.subTabId;

			ApiService.post( uri, { _id: _id, hide: hide } )
			.then( function( response ) {

				this.fetchKeywords ();

			}.bind(this))
			.catch( function(err) {

				this.loading (null,true);

			}.bind(this));

		},

		deleteFilter (reload) {

			let l;

			switch (this.filter) {
				case 'paa' : l = 'PAA'; break;
				case 'auto' : l = 'Auto Suggest'; break;
				case 'content-ideas' : l = 'Supporting Content Ideas'; break;
			}

			this.$dialog
				.confirm( 'Delete all '+l+' for "'+this.searchKeyword+'"?', { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					this.loading ("Deleting "+l+"...");

					let uri = this.apiURL + this.filter + '/' + this.md5Key + '/' + this.tabId;

					ApiService.delete( uri )
					.then( function( response ) {
						
						if ( reload ) {

							this.submitSecondary ();

						}
						else {

							this.loading (null,true);

						}

					}.bind(this))
					.catch( function(err) {

						this.loading (null,true);
						general.$snotify( this, 'error', 'Delete ' + l, err );

					}.bind(this));

				}.bind(this))
				.catch(function() {});

		},

		clickedHide ( keywordInfo, hide ) {
			
			this.submitSecondary ( keywordInfo, ['hide'], hide );

		},

		clickedHighlightPAA (keywordInfo) {

			this.highlighted = this.highlighted === keywordInfo.key ? -1 : keywordInfo.key;

		},

		clickedPAA ( keywordInfo ) {

			this.$dialog
				.confirm( 'Do you want to fetch PAA for "'+keywordInfo.label.replace('?','')+'"?', { okText: 'Yes', cancelText: 'Cancel',})
				.then(function() {

					this.highlighted = keywordInfo.key;

					this.submitSecondary ( keywordInfo, ['fetch'] );

				}.bind(this))
				.catch(function() {});

		},

		submitSecondary ( keywordInfo, uriAppend, hide, md5Key, filter, tabId ) {
			
			let msg, 
				action = 'get', 
				body = {};
				
			filter = filter || this.filter;

			tabId = tabId || this.tabId;

			md5Key = md5Key || this.md5Key;
			
			if ( uriAppend ) {

				if ( !Array.isArray(uriAppend) ) uriAppend = [uriAppend];

			}
			else {

				uriAppend = [];

			}
			
			switch (filter) {
				case 'paa' : msg = typeof hide !== 'undefined' ? 'Updating PAA...' : 'Fetching PAA...'; break;
				case 'auto' : msg = 'Fetching Auto-Suggest...'; break;
				case 'content-ideas' : msg = 'Fetching Supporting Content Ideas...'; break;
				case 'topic-cluster' : msg = 'Generating your Topic Cluster...'; break;
			}

			if ( msg ) this.loading(msg);

			let uri = this.apiURL + filter + '/' +  md5Key + '/' + tabId;

			if ( this.subTabId && ['paa','topic-cluster'].indexOf(filter) ) {

				uri = this.apiURL + filter + '/sub-tab/' +  md5Key + '/' + tabId + '/' + this.subTabId;

			}

			if ( uriAppend.length > 0 ) {

				uri += '/' + uriAppend.join('/');

			}

			if ( ( filter === 'to-improve' || filter === 'topic-cluster' ) && !!keywordInfo && !!keywordInfo.dropdown ) {

				uri += ( '/' + keywordInfo.dropdown );

			}
			else if ( keywordInfo && Object.keys(keywordInfo).length > 0 ) {

				if ( this.filter === 'paa' ) {

					let keys = [keywordInfo.key];

					if ( keywordInfo.parents ) keys = [...keys,...keywordInfo.parents];

					keys.reverse();

					body.keywordKeys = keys;

				}

				if ( this.filter === 'topic-cluster' ) {

					body = keywordInfo;
					msg = 'Updating your Topic Cluster...';

				}
				
				if ( typeof hide !== 'undefined' ) {

					body.hide = hide;

				}

				action = 'post';

			}
			
            ApiService[action]( uri + this.queryString, body )
            .then( function( response ) {

                this.loading (null,true);

				if ( typeof response.data === 'string' ) {

					this.fetchKeywords(true);

				}
				else {

					if ( response.data.checking || this.isSearchPage ) {

						if ( response.data.response ) {

							this.isSearchPage ? this.getList () : this.fetchKeywords(true);

						}
						else {

							general.$snotify( this, 'error', 'Error', response.data.responseMsg );

						}

						this.updateVar( { varName:'reloadAnalysisCredits', info: true } ); 

					}
					else {

						if ( this.filter === 'topic-cluster' ) {

							this.topicalClusterIdeasAll = response.data;

						}

						if ( this.filter === 'paa' ) {

							this.paaAll = response.data;

						}

						if ( this.filter === 'content-ideas' ) {

							this['content-ideas'] = response.data;
							this['content-ideas'].checked = true;

						}

						if ( this.filter === 'to-improve' ) {

							this['to-improve'] = response.data;
							this['to-improve'].checked = true;

						}

					}

				}
                
            }.bind(this))
            .catch( function(err) {

                this.loading (null,true);
				general.$snotify( this, 'error', 'Error', err );

            }.bind(this));

		},

        submitKeywords(info) {

			this.loading ( this.pageType === 'keyword' ? "Fetching Keywords..." : "One moment..." );

			let vars = { 
				keyword: info.searchTerm, 
				countryCode: info.dropdown, 
				language: info.dropdown2,
				urlDefaultAction: info.urlDefaultAction
			};

			if ( this.tab && ( this.tab.type === 'all' || this.tab.type === 'ideas' || this.tab.type === 'ideas2' ) && this.allStatus === 'error' ) {

				vars.retry = true;

			}

            ApiService.post( this.apiURL + 'keyword-ideas/' + this.pageType, vars )
            .then( function( response ) {

				if ( vars.retry ) {

					this.allStatus = 'pending';
					this.periodicalCheck ();

				}

				if ( this.tabId && !vars.retry && this.filter === 'all' ) {

					window.location.assign( '/' + this.pageName + '/overview/' + response.data.key + '/' + response.data.tabId )

				}
				else {

                	this.$router.push( '/' + this.pageName + '/overview/' + response.data.key + '/' + response.data.tabId );

				}

            }.bind(this))
            .catch( function(err) {

                this.loading (null,true);
				general.$snotify( this, 'error', 'Keyword Ideas', err );

            }.bind(this));

        },

		search(info) {
			
			let table = this.currentTable ();

			Vue.set( table, 'search', info );
			Vue.set( table, 'page', 1 );
			window.location.hash = '';
			this.fetchKeywords ();

		},

		sort(info) {

			let table = this.currentTable ();

			Vue.set( table, 'sorted', info );
			Vue.set( table, 'page', 1 );
			
			if ( info.init ) { delete table.sorted.init; return; }

			this.fetchKeywords ();

		},

		pagination(info) {

			let table = this.currentTable ();

			Vue.set( table, 'page', info.page );
			this.fetchKeywords ();

		},
		fetchKeywords ( reload, onlyRefreshIfIdeas2Complete ) {
	
			if ( !reload && !onlyRefreshIfIdeas2Complete ) this.table.loading = true;

			if ( this.isSearchPage ){

				this.getList ();
				return;

			}

			if ( !this.initialLoad ) {

				this.loading ();

			}

			if ( !this.pageType || !this.md5Key || !this.tabId ) {

				return;

			}

			let uri = this.apiURL + 'keyword-ideas/' + this.pageType + '/' + this.md5Key + '/' + this.tabId;

			if ( this.subTabId ) uri += '/' + this.subTabId;

			this.updateVar( { varName:'instructionalTipsLoading', info: true } ); 

			ApiService.get( uri + this.queryString )
            .then( function( response ) {

				this.loading (null,true);

				this.updateVar( { varName:'instructionalTipsLoading', info: false } ); 
	
				this.searchKeyword = response.data.keyword;
				this.searchKeywordOriginal = response.data.keyword;
				this.searchCountry = response.data.country;
				this.searchLanguage = response.data.language || null;
				this.paaAll = response.data.paa || null;
				this.projectsAssigned = response.data.projects || [];
				this.autoAll = response.data.auto || null;
				this.easyAll = response.data.easy || null;
				this.topicalClusterIdeasAll = response.data.topicalClusterIdeas || null;
				
				Vue.set( this, 'tasks', response.data.tasks || [] );
				Vue.set( this, 'googleURL', response.data.googleURL || [] );
				Vue.set( this, 'matchTypeCounts', response.data.matchTypeCounts || {} );

				if ( this.termCounts.length == 0 ) {
					Vue.set( this, 'termCounts', response.data.termCounts || [] );
					Vue.set( this, 'termCountsSelected', response.data.termCountsSelected || [] );
				}

				if ( this.projectsAssigned.length === 1 && !this.project ) {

					this.project = this.projectsAssigned[0];

				}
				
				this.processTabs (response);

				if ( response.data.tableFilters ) {

					this.searchFilters = response.data.tableFilters;

				}
				
				this['content-ideas'] = response.data['content-ideas'] || null;

				if ( this['content-ideas'] ) this['content-ideas'].checked = true;

				if ( !onlyRefreshIfIdeas2Complete || !this.showStillProcessing ) {

					Object.keys(response.data.results).forEach ( function (k) {

						if ( k === 'filters' ) { 

							this.filters = this.filters || {};

							Object.keys(response.data.results[k]).forEach ( function (filterType) {

								if ( !this.filters[filterType] ) {

									Vue.set( this.filters, filterType, response.data.results[k][filterType] );

									let f = [...this.filters[filterType]];

									if ( this.actualTab && this.actualTab.query && this.actualTab.query.startsWith && filterType === this.filter ) {

										f = this.actualTab.query.startsWith;

									}

									Vue.set( this.selectedFilters, filterType, f );

								}

							}.bind(this));

							return;

						}

						this.table[k] = response.data.results[k];

						if ( this.table.matchTypeCounts )this.matchTypeCounts = this.table.matchTypeCounts;

					}.bind(this));

					this.table.loading = false;

					setTimeout( function () { 
						this.initialLoad = true; 
						if ( this.filter === 'to-improve' ) this.periodicalCheck ();
					}.bind(this), 100 );

				}

				this.periodicalCheck ();

				this.reloadInstructionalTips();

            }.bind(this))
            .catch( function(err) {
				
				general.$snotify( this, 'error', 'Keyword Ideas', err );
				this.table.loading = false;
				this.initialLoad = true;
				this.$router.push( '/' + this.pageName );
				this.loading (null,true);

            }.bind(this));

		},
		getList (created,noLoad) {

			if ( !this.pageType ) return;

			if ( created ) {

				this.updateLoadingText(true);

			}
			else if ( this.tableItemSelected.length > 0 && noLoad ) {

				this.getListTimeout = setTimeout ( function () {
					console.log('get list1');
					this.getList (false,true);

				}.bind(this), 5000 );

				return;

			}

			if ( !noLoad ) this.table.loading = true;

			ApiService.get( this.apiURL + 'ideas-list/' + this.pageType + this.queryString )
			.then( function( response ) {

				let s = this.list.search || {};

				Vue.set( this, 'list', response.data );

				this.list.search = s;

				this.table.loading = false;

				this.loading (null,true);
				this.updateLoadingText();

				if ( this.getListTimeout ) clearTimeout (this.getListTimeout);

				this.getListTimeout = null;

				if ( response.data.inProgress && this.isSearchPage ) {

					this.getListTimeout = setTimeout ( function () {

						this.getList (false,true);

					}.bind(this), 10000 );

				}

			}.bind(this))
			.catch( function(error) {

				this.loading (null,true);
				this.updateLoadingText();

			}.bind(this));

		},
		setup () {

			this.loading ();

			if ( !this.allowedAccess ) return;
			
			if ( this.isSearchPage ) {

				this.getList (true);

			}
			
			if ( !this.isSearchPage && this.$route.name !== ( this.pageName + '-run' ) ) this.fetchKeywords ();
			
			if ( this.$route.name === ( this.pageName + '-run' ) ) {

				let vars = {
					searchTerm: this.$route.params.keyword,
					dropdown: this.$route.params.country
				};

				if ( this.$route.params.language !== 'null' ) {

					vars.dropdown2 = this.$route.params.language;

				}

				this.submitKeywords(vars);

			}

			ApiService.get( 'fields/keyword' )
			.then( function(info) {
				
				this.fields = info.data.fields;
				this.comparisons = info.data.comparisons;
				this.languages = [];
				this.countries = [];
				['languages','countries'].forEach ( function (t) {
					info.data.selects[t].forEach ( function (c) {
						c.value = c._id2 || c._id;
						this[t].push(c);
					}.bind(this));
				}.bind(this));

			}.bind(this))
			.catch( function(err) {}.bind(this));

		}
		
	},

	beforeDestroy () {
		
		this.clearTO (true);

	},
	
	created() {

		this.clearTO (true);

		let hash = window.location.hash.replace('#','');

		if ( hash ) {
			
			Vue.set( this.preSearchFilters, 'projects', [hash] );
			Vue.set( this.list, 'search', { projects: [hash] } );

		}

		this.setup ();

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_settings.less';
@import './../assets/css/less/_helper.less';

.to-improve-info {
	&.results {
		padding: 10px 0 !important;
	}
	span {
		font-weight: 500;
		&.link {
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
		}
	}
}

.one-click {

	text-align: right;
	margin-right: 10px;

	.one-click-switcher {

		margin-right: 5px;

	}

}

.word-breakdowns {

	display: none;

}

.ib {
	display: inline;
}

.content-header {

	.content-header-inner {

		.content-header-title {

			margin: 0 0 5px;
			text-align: center;

		}

		p {

			margin: 0;
			text-align: center;

		}


	}

}

.not-allowed-wrap {
	min-height: 60vh !important;
}

.not-allowed-bg {

	background-image: url("../assets/img/content-keywords.jpg");
	filter: blur(8px);
	-webkit-filter: blur(10px);
	height: 100%;
	background-position: 20px 20px;
	background-repeat: no-repeat;
	background-size: auto 100%;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.not-allowed {

	.vertical-align;
	background-color: rgba(255,255,255,0.65);
	padding: 20px;
	width: 80vw;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	.header-info {
		padding: 0;
		.header-title {
			margin: 0;
		}
	}

	.not-ready {
		margin: 10px auto 5px;
		text-align: center;
		max-width: 400px;
		padding: 0;
		a {
			&:not(.large-button) {
				color: @formDefaultColour;
			}
		}
	}

	.video {

		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		cursor: pointer;

		span {
			padding-left: 10px;
		}

		svg, span {
			display: inline-block;
		}

		svg {

			width: 50px;

			display: inline-block;

		}

	}

}

.header-info {

	padding: 20px 10px;

	.header-title {

		margin: 0 0 5px;
		text-align: center;

	}

	p {

		margin: 0;
		text-align: center;

	}

}

.pending-info {

	text-align: center;
	padding: 80px 20px 40px;
	display: block;

	.pending-loader {

		margin-top: 15px;

	}

	h3 {

		margin: 0 0 10px;

	}

	p {

		max-width: 400px;
		margin: 0 auto;

	}

	&.base {

		display: inline;
		padding: 0;

		h3 {

			margin: 0;

		}

		p {

			max-width: none;
			margin: 0 80px;

		}

		.large-button {

			margin:5px 0 10px;

		}

	}

	&.error {

		h3, p {

			color: @red;

		}

	}

	.actions-bar {

		background-color: rgba(255, 255, 255, 0.9);

	}

}

.result-menu {

	.result-menu-item {

		background-color: @darkContrast;
		color: #fff;
		display: block;
		border-top: 1px solid #fff;
		padding: 8px 15px 8px 5px;
		font-size: 14px;
		cursor: pointer;
		word-break: break-all;
		.trans();
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;

		&:first-child {

			border: none;

		}

		&.selected, &:hover {

			width: 105%;
			border-radius: 0 5px 5px 0;

		}

		&.selected {

			width: 110%;

		}

		svg {

			.opacity(0.5);

			&:hover {

				.opacity(1);

			}

		}

		&.hide {

			.opacity(0.5);

			svg {

				.opacity(1);

			}

			&.hideHidden {

				display: none;
					
			}

		}

	}

}

.filters {

	padding: 0px 10px 6px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);

	.filter-title {

		font-size: 16px;
		margin-bottom: 5px;

		span {

			color: @orange;
			cursor: pointer;

			&:hover {

				text-decoration: underline;

			}

		}

	}
}

.outer-pad {

	&.hidden-from-export {

		.result-wrap, .filters {

			.opacity(0.5);

		}

	}

	&.overflow {

		overflow: visible;

	}

	.info-panel {

		min-height: 300px;

		&.no-min-height {

			min-height: 0;


		}

		&.overflow {

			overflow: visible;
		}

	}

}

.main-title {
	margin: 0 0 20px 10px;
    font-size: 20px;
}

@media screen and (min-width: 520px) {

	.content-header {

		.content-header-inner {

			.content-header-title {

				display: inline-block;

			}

			p {

				margin: 0;
				text-align: center;

			}



		}

	}

}

@media screen and (min-width: 768px) {

	.result-wrap {

		&.has-result-menu {

			.result-menu {

				width: 15%;
				display: inline-block;
				vertical-align: top;
				margin: 24px 0 0;

			}

			.results {

				width: 78%;
				margin-left: 4%;
				display: inline-block;
				vertical-align: top;

			}

		}

	}

	.not-allowed {

		width: 500px;

	}

	.pending-info {

		&.base {

			text-align: left;

			h3 {

				margin: 0;

			}

			p {

				max-width: none;
				margin: 0 0 10px;
				padding-right: 400px;

			}

			.large-button {

				margin:0;
				position: absolute;
				top: 50%;
				margin-top: -14px;
				right: 165px;
				z-index: 2;

			}

		}

		&.fullMenu {

			&.base {

				.large-button {

					right: 100px;

				}

				p {

					padding-right: 330px;

				}

			}

		}

	}

}

@media screen and (min-width: 960px) {

	.one-click {

		margin-top: 20px;
		margin-right: 14px;

	}

	.not-allowed-wrap {
		
		min-height: 70vh !important;

	}

	.not-allowed-bg {

		background-size: 100% auto;

	}

	.word-breakdowns {

		display: inline-block;
		width: 16%;
		vertical-align: top;
		margin-top: 136px;
		box-sizing: border-box;
		padding: 0 0 0 12px;
		margin-left: 13px;
		border-left: 1px solid rgba(0, 0, 0, 0.05);

		.word-breakdowns-title {
			font-size: 16px;
			margin-bottom: 5px;
		}

		.word-breakdown {

			display: block;
			margin-left: 0;

			&.related {

				margin-left: 10px;

			}

		}

	}

	.has-word-breakdowns {

		&.table-wrap {

			width: 82%;
			display: inline-block;
			vertical-align: top;

		}

	}

	.header-info {

		padding: 20px 10px 0;

		.header-title {

			&:not(.center) {

				text-align: left;

			}

		}

		p {

			text-align: left;

		}

	}

	.main-title {
		margin: 22px 0 8px;
		font-size: 22px;
		display: inline-block;
		width: 80%;
	}

	.show-hidden {

		display: inline-block;
		width: 20%;
		text-align: right;

		.switcher {

			display: inline-block;
			text-align: left;

		}

	}

	.filters {

		padding: 8px 0 0;
		position: absolute;
		left: 320px;
		border: none;

	}

	.info-panel {

		padding-top: 0;
		overflow: hidden;

		.info-panel-inner, .info-panel-inner-inner {

			display: inline;

		}

		&.has-side-menu {

			padding-left: 0;
			overflow: visible;

			.info-panel-inner {

				display: flex;

			}

			.info-panel-inner-inner {

				width: 84%;
    			margin-left: 15px;
				display: inline-block;

			}

			.search-box-wrap {

				padding: 10px 0 0 5px;

			}

		}

		&.has-menu {

			padding-top: 0;

		}

	}

}

@media screen and (min-width: 1024px) {

	.results {

		margin-top: 0px;

	}

}

@media screen and (min-width: 1360px) {

	.results {

		margin-top: 0px;

	}

	.word-breakdowns {

		width: 12%;

	}

	.has-word-breakdowns {

		&.table-wrap {

			width: 86%;

		}

	}

}

@media screen and (min-width: 1920px) {

	.word-breakdowns {

		width: 8%;

	}

	.has-word-breakdowns {

		&.table-wrap {

			width: 90%;

		}

	}

}

</style>
